import React, { useState } from "react";
import { makeStyles } from '@mui/styles';
// import { styled } from '@mui/material/styles';
import {Cancel} from '@mui/icons-material';
import styled from "styled-components";
import { Button as AntdButton } from "antd";
import { get, map } from "lodash";
import { useAllDistrictTeacher } from "store/users/selectors";

const ListLesson = ({ filterData, currentUser, handleUpdateOpenPopUp }) => {
  const isCanvasUser = !!get(currentUser, "canvas_id");
  const [loader, setLoader] = useState(false);
  const allDistrictTeacher = useAllDistrictTeacher();

  return (
    <LessonContainer isCanvasUser={isCanvasUser}>
      <LessonModal style={{ position: "relative" }} view={true}>
        <span
          onClick={() => {
            handleUpdateOpenPopUp(
              { type: "sentenceStarterOption", open: true },
              "set"
            );
          }}
        >
          <Cancel
            style={{
              float: "right",
              fontSize: 25,
              color: "red",
              background: "white",
              borderRadius: 20,
              cursor: "pointer",
              marginBottom: 5,
            }}
          />
        </span>
        <div className="shared-lesson-container">
          <div className="shared-lesson">Shared Sentence Starter</div>
          <div className="shared-lesson-title-container">
            {map(filterData, (item) => {
              const findShareBy = allDistrictTeacher.find(
                (obj) => item.userId === obj?.id
              );
              return (
                <>
                  <div
                    className="share-by-lesson"
                    onClick={() => {
                      handleUpdateOpenPopUp(
                        {
                          type: "viewSharedSentenceStarter",
                          data: item,
                          open: true,
                        },
                        "set"
                      );
                    }}
                  >
                    {/* <span className="title-for-share">
                      {`${
                        // from !== "ebook"
                        //   ? "Differentiation"
                        //   : `Differentiation (P. ${getMaskIdFrom}-${getMaskIdTo})`
                      }`}
                      -
                    </span> */}
                    <span className="shared-by-text">&nbsp; shared by:</span>
                    <span className="shared-by-teacher-name">{` ${findShareBy?.firstName} ${findShareBy?.lastName}`}</span>
                  </div>
                  <div className="share-by-line-lesson" />
                </>
              );
            })}
          </div>
          <div
            className="share-by-Back-lesson"
            onClick={() => {
              handleUpdateOpenPopUp(
                { type: "sentenceStarterOption", open: true },
                "set"
              );
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <AntdButton
                className="back-button-super-lesson"
                type="primary"
                loading={loader}
                style={{
                  borderRadius: 10,
                  minWidth: 179,
                  backgroundColor: "#017216",
                  border: "1px solid white",
                  minHeight: 55,
                  fontSize: 22,
                }}
              >
                {"Back"}
              </AntdButton>
            </span>
          </div>
        </div>
      </LessonModal>
    </LessonContainer>
  );
};

export default ListLesson;

const LessonContainer = styled.section`
  padding-top: 15px;
  padding-left: 27px;
  padding-right: 33px;
  padding-bottom: 20px;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 50;
  @media (max-width: 700px) {
    display: ${(p) => (p.isCanvasUser ? "unset" : "none")};
  }
`;

const LessonModal = styled.div`
  background: #000f4c;
  border-radius: 11px;
  padding-left: ${(p) => (p.view ? "51px" : "19px")};
  padding-right: ${(p) => (p.view ? "51px" : "19px")};
  padding-bottom: ${(p) => (p.view ? "34px" : "26px")};
  padding-top: ${(p) => (p.view ? "51px" : "10px")};
  height: ${(p) => (p.view ? "unset" : "100%")};
  // overflow: hidden auto;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  overflow: auto;
`;

const SuperLessonLogoImg = styled.img`
  @media (max-width: 768px) {
    width: 57px;
    height: 51px;
  }
`;

const BoxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 15px;
  font-style: italic;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;

  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
  }
`;

const FieldShareBox = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  // width: 108px;
  height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  flex: 1;
  max-width: 241px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
  }
`;

const WhiteBox = styled.div`
  height: calc(100% - 185px);
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #e8e8e8;
  background: #fff;
  width: 100%;
  // height: 100%;
  // max-height: 700px;

  margin-top: 24px;
  overflow-x: hidden;
  background-color: #fff;
  overflow-y: auto;

  @media (max-width: 1367px) {
    height: calc(100% - 195px);
  }

  @media (max-width: 768px) {
    height: calc(100% - 188px);
  }
  @media print {
    position: relative;
    width: auto;
    height: auto;
    overflow: visible;
    display: block;

    &,
    & * {
      page-break-inside: avoid;
    }

    .lesson-plan-container {
      page-break-after: avoid;
    }
  }
`;

const useStyles = makeStyles({
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent !important",
    },
    menuItemText: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: "150px",
      display: "block",
    },
    disabledButton: {
      color: "white",
      "&.Mui-disabled": {
        color: "white !important",
      },
    },
  },
});